import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Users, CheckCircle,
    FileText, MessageCircle, Calendar,
    Bell,
    TrendingUp, Megaphone,
    MapPin, Mail,
    BarChart3, Instagram, PhoneCall,
    Footprints, Eye, Smartphone, Newspaper,
    Monitor, Crown
} from 'lucide-react';

function LabPromoLanding() {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleSignUp = () => navigate('/signup?type=lab&promo=lab');

    const promoChannels = [
        {
            icon: Newspaper, title: '덴탈아리랑 배너 광고', color: '#6366f1',
            desc: '치과업계 대표 매체 덴탈아리랑에\n배너 광고로 기공소를 노출합니다.',
            tag: '온라인 매체'
        },
        {
            icon: Newspaper, title: '치과신문 배너 광고', color: '#3b82f6',
            desc: '치과신문 웹사이트에\n배너 광고를 게재합니다.',
            tag: '온라인 매체'
        },
        {
            icon: Footprints, title: '직접 방문 영업', color: '#10b981',
            desc: '전국 치과를 직접 방문하여\n기공소를 소개하고 QR코드를 배포합니다.',
            tag: '오프라인'
        },
        {
            icon: PhoneCall, title: '전화 영업', color: '#f59e0b',
            desc: '치과에 직접 전화하여\n기공소 서비스를 안내합니다.',
            tag: '오프라인'
        },
        {
            icon: Instagram, title: '인스타그램 광고', color: '#f43f5e',
            desc: '치과 원장, 실장 타겟\nSNS 유료 광고를 집행합니다.',
            tag: 'SNS'
        },
    ];

    const features = [
        { icon: FileText, title: '주문 관리', desc: '의뢰서 접수~완료 한눈에' },
        { icon: MessageCircle, title: '실시간 채팅', desc: '거래처와 바로 소통' },
        { icon: Calendar, title: '일정 관리', desc: '납기일 캘린더 관리' },
        { icon: BarChart3, title: '거래명세서', desc: '자동 생성 및 발행' },
        { icon: Mail, title: '이메일 파싱', desc: '의뢰서 자동 수집' },
        { icon: Bell, title: '실시간 알림', desc: '새 주문/메시지 알림' },
        { icon: TrendingUp, title: '매출 분석', desc: '거래처별 통계' },
        { icon: Smartphone, title: '모바일 앱', desc: 'iOS/Android 지원' },
    ];

    const faqs = [
        { q: '비용이 얼마인가요?', a: '구독료는 상담 시 안내드립니다. 별도 수수료나 추가 비용은 없습니다.' },
        { q: '계약 기간이 있나요?', a: '없습니다. 월 단위 구독으로 언제든 해지할 수 있습니다.' },
        { q: '어떤 매체에 광고되나요?', a: '덴탈아리랑, 치과신문 등 치과업계 주요 매체에 배너 광고가 게재됩니다. 추가로 직접 방문, 전화 영업, 인스타그램 광고도 진행합니다.' },
        { q: '등록하면 뭐가 되나요?', a: '기공소 프로필 페이지가 생성되어 단가표, 포트폴리오, 전문분야 등을 치과에 보여줄 수 있습니다. 치과에서 직접 검색하고 연락할 수 있습니다.' },
        { q: '덴탈클러스터 기능도 쓸 수 있나요?', a: '네. 주문 관리, 채팅, 거래명세서, 일정관리, 매출 분석 등 기공소 운영에 필요한 모든 기능이 구독에 포함됩니다.' },
    ];

    return (
        <div style={{ backgroundColor: '#0f172a', color: '#fff', minHeight: '100vh' }} onContextMenu={e => e.preventDefault()}>

            {/* ══════ 히어로 섹션 ══════ */}
            <section style={{
                padding: isMobile ? '60px 20px 40px' : '80px 40px 60px',
                maxWidth: 1200, margin: '0 auto', textAlign: 'center',
            }}>
                <div style={{
                    display: 'inline-flex', alignItems: 'center', gap: 8,
                    padding: '8px 20px', backgroundColor: 'rgba(99,102,241,0.2)',
                    borderRadius: 30, marginBottom: 24, border: '1px solid rgba(99,102,241,0.3)',
                }}>
                    <Megaphone size={16} color="#a5b4fc" />
                    <span style={{ fontSize: 14, fontWeight: 600, color: '#a5b4fc' }}>기공소 홍보 + 운영 올인원</span>
                </div>

                <h1 style={{
                    fontSize: isMobile ? 26 : 44, fontWeight: 900, lineHeight: 1.2,
                    margin: '0 0 20px', letterSpacing: '-1px',
                }}>
                    기공소 <span style={{ color: '#818cf8' }}>홍보·운영</span>을 한 번에.
                </h1>

                <p style={{
                    fontSize: isMobile ? 16 : 20, color: '#94a3b8', lineHeight: 1.7,
                    margin: '0 0 36px', maxWidth: 640, marginLeft: 'auto', marginRight: 'auto',
                }}>
                    덴탈아리랑 · 치과신문 배너 광고부터<br />
                    직접 방문, 전화, 인스타그램까지.<br />
                    기공소 운영 기능은 덤입니다.
                </p>

                <button onClick={handleSignUp} style={{
                    padding: isMobile ? '16px 36px' : '18px 48px',
                    fontSize: isMobile ? 16 : 18, fontWeight: 700,
                    backgroundColor: '#6366f1', color: '#fff', border: 'none',
                    borderRadius: 14, cursor: 'pointer', display: 'inline-flex',
                    alignItems: 'center', gap: 10,
                }}>
                    <Crown size={20} /> 구독 시작하기
                </button>
                <p style={{ fontSize: 13, color: '#64748b', marginTop: 12 }}>약정 없음 · 언제든 해지 가능</p>

                {/* 구독 포함 사항 */}
                <div style={{
                    marginTop: 40, display: 'inline-flex', alignItems: 'center', gap: isMobile ? 16 : 32,
                    padding: isMobile ? '20px 24px' : '24px 40px',
                    backgroundColor: 'rgba(99,102,241,0.08)', borderRadius: 20,
                    border: '1px solid rgba(99,102,241,0.15)', flexWrap: 'wrap', justifyContent: 'center',
                }}>
                    <div style={{ textAlign: 'left' }}>
                        <div style={{ fontSize: 14, color: '#e2e8f0', fontWeight: 600, marginBottom: 6 }}>구독에 포함된 것</div>
                        <div style={{ fontSize: 13, color: '#94a3b8', lineHeight: 1.7 }}>
                            5개 채널 홍보 + 기공소 운영 기능<br />
                            추가 수수료 없음 · 약정 없음
                        </div>
                    </div>
                </div>
            </section>

            {/* ══════ 고민 포인트 섹션 ══════ */}
            <section style={{
                padding: isMobile ? '40px 20px' : '60px 40px',
                maxWidth: 1200, margin: '0 auto',
            }}>
                <h2 style={{ textAlign: 'center', fontSize: isMobile ? 24 : 32, fontWeight: 800, marginBottom: 32 }}>
                    이런 고민, <span style={{ color: '#818cf8' }}>있으시죠?</span>
                </h2>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
                    gap: 16, maxWidth: 900, margin: '0 auto',
                }}>
                    {[
                        { title: '영업할 시간이 없다', desc: '기공에만 집중하고 싶은데 치과를 못 찾겠다', emoji: '😩' },
                        { title: '영업사원 운영이 부담된다', desc: '고정비 부담은 크고 효과는 예측 어렵다', emoji: '💸' },
                        { title: '어디에 홍보해야 할지 모르겠다', desc: '온라인 마케팅은 어렵다', emoji: '🤷' },
                    ].map((item, i) => (
                        <div key={i} style={{
                            padding: '24px', backgroundColor: 'rgba(255,255,255,0.04)',
                            borderRadius: 16, border: '1px solid rgba(255,255,255,0.08)',
                            textAlign: 'center',
                        }}>
                            <div style={{ fontSize: 36, marginBottom: 12 }}>{item.emoji}</div>
                            <div style={{ fontSize: 16, fontWeight: 800, marginBottom: 8, color: '#e2e8f0' }}>{item.title}</div>
                            <div style={{ fontSize: 14, color: '#94a3b8', lineHeight: 1.7, whiteSpace: 'pre-line' }}>{item.desc}</div>
                        </div>
                    ))}
                </div>

                <div style={{ textAlign: 'center', marginTop: 32 }}>
                    <p style={{ fontSize: isMobile ? 17 : 20, fontWeight: 800, color: '#818cf8', marginBottom: 16 }}>
                        덴탈클러스터가 전부 해결합니다
                    </p>
                    <button onClick={handleSignUp} style={{
                        padding: '14px 32px', fontSize: 15, fontWeight: 700,
                        backgroundColor: '#6366f1', color: '#fff', border: 'none',
                        borderRadius: 12, cursor: 'pointer', display: 'inline-flex',
                        alignItems: 'center', gap: 8,
                    }}>
                        구독 시작하기
                    </button>
                </div>
            </section>

            {/* ══════ 등록 기공소 예시 (스크린샷) ══════ */}
            <section style={{
                padding: isMobile ? '40px 20px' : '60px 40px',
                backgroundColor: 'rgba(255,255,255,0.03)',
            }}>
                <div style={{ maxWidth: 1200, margin: '0 auto' }}>
                    <h2 style={{ textAlign: 'center', fontSize: isMobile ? 24 : 32, fontWeight: 800, marginBottom: 12 }}>
                        등록하면 이렇게 <span style={{ color: '#818cf8' }}>노출</span>됩니다
                    </h2>
                    <p style={{ textAlign: 'center', color: '#94a3b8', fontSize: 16, marginBottom: 32 }}>
                        치과에서 기공소를 검색하고 비교할 수 있는 전용 페이지
                    </p>

                    {/* 스크린샷 영역 */}
                    <div style={{
                        maxWidth: 900, margin: '0 auto',
                        borderRadius: 20, overflow: 'hidden',
                        border: '1px solid rgba(255,255,255,0.1)',
                        backgroundColor: '#1e293b',
                        boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
                    }}>
                        {/* 실제 스크린샷 */}
                        <img
                            src="/images/promo/find-lab-screenshot.jpg"
                            alt="기공소 검색 페이지 예시"
                            style={{
                                width: '100%', display: 'block',
                                pointerEvents: 'none', userSelect: 'none', WebkitUserDrag: 'none',
                            }}
                            draggable={false}
                            onError={e => {
                                e.target.style.display = 'none';
                                e.target.nextSibling.style.display = 'flex';
                            }}
                        />
                        {/* 이미지 로드 실패 시 placeholder */}
                        <div style={{
                            display: 'none', flexDirection: 'column',
                            alignItems: 'center', justifyContent: 'center',
                            padding: isMobile ? '60px 20px' : '80px 40px',
                            color: '#475569',
                        }}>
                            <Monitor size={56} />
                            <p style={{ marginTop: 16, fontSize: 16, fontWeight: 600 }}>기공소 검색 페이지</p>
                            <p style={{ marginTop: 8, fontSize: 13, color: '#64748b', textAlign: 'center', lineHeight: 1.6 }}>
                                치과에서 지역, 전문분야별로 기공소를 검색하고<br />
                                단가표, 포트폴리오, 리뷰를 비교할 수 있습니다
                            </p>
                        </div>
                    </div>

                    {/* 설명 포인트 */}
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
                        gap: 16, maxWidth: 900, margin: '24px auto 0',
                    }}>
                        {[
                            { title: '프로필 페이지', desc: '단가표, 포트폴리오, 전문분야 소개' },
                            { title: '치과에서 검색', desc: '지역/분야별 기공소 탐색' },
                            { title: '바로 연결', desc: '중개 요청으로 거래 시작' },
                        ].map((item, i) => (
                            <div key={i} style={{
                                padding: '16px 20px', backgroundColor: 'rgba(255,255,255,0.05)',
                                borderRadius: 12, border: '1px solid rgba(255,255,255,0.06)',
                                textAlign: 'center',
                            }}>
                                <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 4 }}>{item.title}</div>
                                <div style={{ fontSize: 12, color: '#94a3b8' }}>{item.desc}</div>
                            </div>
                        ))}
                    </div>
                </div>

                <div style={{ textAlign: 'center', margin: '24px 0' }}>
                    <button onClick={handleSignUp} style={{ padding: '14px 32px', fontSize: 15, fontWeight: 700, backgroundColor: '#6366f1', color: '#fff', border: 'none', borderRadius: 12, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                        구독 시작하기
                    </button>
                </div>
            </section>

            {/* ══════ 5가지 홍보 채널 ══════ */}
            <section style={{
                padding: isMobile ? '40px 20px' : '60px 40px',
                maxWidth: 1200, margin: '0 auto',
            }}>
                <h2 style={{ textAlign: 'center', fontSize: isMobile ? 24 : 32, fontWeight: 800, marginBottom: 12 }}>
                    <span style={{ color: '#818cf8' }}>5가지 채널</span>로 홍보합니다
                </h2>
                <p style={{ textAlign: 'center', color: '#94a3b8', fontSize: 16, marginBottom: 40 }}>
                    온라인 매체 배너부터 오프라인 방문까지, 모두 포함
                </p>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? '1fr' : 'repeat(5, 1fr)',
                    gap: isMobile ? 12 : 16,
                }}>
                    {promoChannels.map((ch, i) => (
                        <div key={i} style={{
                            padding: isMobile ? '20px 16px' : '28px 16px',
                            backgroundColor: 'rgba(255,255,255,0.04)',
                            borderRadius: 20, border: '1px solid rgba(255,255,255,0.06)',
                            textAlign: 'center',
                            display: 'flex', flexDirection: 'column', alignItems: 'center',
                        }}>
                            <div style={{
                                padding: '4px 12px', borderRadius: 20, marginBottom: 12,
                                backgroundColor: `${ch.color}15`, border: `1px solid ${ch.color}30`,
                            }}>
                                <span style={{ fontSize: 11, fontWeight: 600, color: ch.color }}>{ch.tag}</span>
                            </div>
                            <div style={{
                                width: 56, height: 56, borderRadius: 16,
                                backgroundColor: `${ch.color}20`, display: 'flex',
                                alignItems: 'center', justifyContent: 'center',
                                marginBottom: 14,
                            }}>
                                <ch.icon size={28} color={ch.color} />
                            </div>
                            <h3 style={{ fontSize: 15, fontWeight: 800, margin: '0 0 8px', lineHeight: 1.3 }}>{ch.title}</h3>
                            <p style={{ fontSize: 13, color: '#94a3b8', lineHeight: 1.7, margin: 0, whiteSpace: 'pre-line' }}>
                                {ch.desc}
                            </p>
                        </div>
                    ))}
                </div>

                {/* 모든 비용 포함 강조 */}
                <div style={{
                    marginTop: 32, padding: isMobile ? '16px 20px' : '20px 32px',
                    backgroundColor: 'rgba(16,185,129,0.08)', borderRadius: 16,
                    border: '1px solid rgba(16,185,129,0.15)', textAlign: 'center',
                    maxWidth: 600, marginLeft: 'auto', marginRight: 'auto',
                }}>
                    <p style={{ fontSize: isMobile ? 15 : 17, fontWeight: 700, color: '#10b981', margin: 0 }}>
                        영업사원 없이, 5개 채널 동시 홍보
                    </p>
                    <p style={{ fontSize: 13, color: '#94a3b8', margin: '6px 0 0', lineHeight: 1.6 }}>
                        배너 광고비, 방문 영업비, SNS 광고비 별도 청구 없음
                    </p>
                </div>

                <div style={{ textAlign: 'center', margin: '24px 0' }}>
                    <button onClick={handleSignUp} style={{ padding: '14px 32px', fontSize: 15, fontWeight: 700, backgroundColor: '#6366f1', color: '#fff', border: 'none', borderRadius: 12, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                        구독 시작하기
                    </button>
                </div>
            </section>

            {/* ══════ 직접 방문 영업 사진 갤러리 ══════ */}
            <section style={{
                padding: isMobile ? '40px 20px' : '60px 40px',
                backgroundColor: 'rgba(255,255,255,0.03)',
            }}>
                <div style={{ maxWidth: 1200, margin: '0 auto' }}>
                    <div style={{
                        display: 'inline-flex', alignItems: 'center', gap: 8,
                        padding: '6px 16px', backgroundColor: 'rgba(99,102,241,0.15)',
                        borderRadius: 30, marginBottom: 16,
                        border: '1px solid rgba(99,102,241,0.3)',
                    }}>
                        <Footprints size={14} color="#818cf8" />
                        <span style={{ fontSize: 13, fontWeight: 600, color: '#818cf8' }}>직접 방문 영업 현장</span>
                    </div>

                    <h2 style={{ textAlign: 'center', fontSize: isMobile ? 24 : 32, fontWeight: 800, marginBottom: 12 }}>
                        전국 치과를 <span style={{ color: '#818cf8' }}>직접</span> 찾아갑니다
                    </h2>
                    <p style={{ textAlign: 'center', color: '#94a3b8', fontSize: 16, marginBottom: 36 }}>
                        매일 발로 뛰며 기공소를 알리고 있습니다
                    </p>

                    {/* 사진 그리드 */}
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
                        gap: isMobile ? 8 : 12,
                        maxWidth: 1000, margin: '0 auto',
                    }}>
                        {[1, 2, 3, 4, 5, 6, 7, 8].map((n) => (
                            <div key={n} style={{
                                aspectRatio: '1',
                                borderRadius: 12, overflow: 'hidden',
                                border: '1px solid rgba(255,255,255,0.08)',
                                backgroundColor: '#1e293b',
                                position: 'relative',
                            }}>
                                <img
                                    src={`/images/promo/sales-${n}.jpg`}
                                    alt={`영업 현장 ${n}`}
                                    style={{
                                        width: '100%', height: '100%', objectFit: 'cover',
                                        pointerEvents: 'none', userSelect: 'none', WebkitUserDrag: 'none',
                                    }}
                                    draggable={false}
                                    onError={e => { e.target.style.display = 'none'; }}
                                />
                                {/* 어둡게 오버레이 */}
                                <div style={{
                                    position: 'absolute', bottom: 0, left: 0, right: 0,
                                    padding: '8px 10px',
                                    background: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
                                    fontSize: 11, color: '#fff', fontWeight: 600,
                                }}>
                                    영업 현장 {n}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* 목표 메시지 */}
                    <div style={{
                        marginTop: 24, padding: '14px 24px',
                        backgroundColor: 'rgba(99,102,241,0.08)',
                        border: '1px solid rgba(99,102,241,0.15)',
                        borderRadius: 14, textAlign: 'center',
                        maxWidth: 700, marginLeft: 'auto', marginRight: 'auto',
                    }}>
                        <p style={{ fontSize: isMobile ? 14 : 16, fontWeight: 700, color: '#818cf8', margin: 0 }}>
                            🎯 2026년 목표: 전국 치과 3,000곳 직접 방문
                        </p>
                        <p style={{ fontSize: 12, color: '#94a3b8', margin: '4px 0 0' }}>
                            기공소는 본업에 집중하시고, 영업은 저희가 책임집니다
                        </p>
                    </div>
                </div>
            </section>

            {/* ══════ 유입 통계 제공 ══════ */}
            <section style={{
                padding: isMobile ? '40px 20px' : '60px 40px',
                maxWidth: 1200, margin: '0 auto',
            }}>
                <div style={{
                    display: 'inline-flex', alignItems: 'center', gap: 8,
                    padding: '6px 16px', backgroundColor: 'rgba(16,185,129,0.15)',
                    borderRadius: 30, marginBottom: 16,
                    border: '1px solid rgba(16,185,129,0.3)',
                }}>
                    <BarChart3 size={14} color="#10b981" />
                    <span style={{ fontSize: 13, fontWeight: 600, color: '#10b981' }}>실시간 유입 통계 제공</span>
                </div>

                <h2 style={{ textAlign: 'center', fontSize: isMobile ? 24 : 32, fontWeight: 800, marginBottom: 12 }}>
                    광고 효과를 <span style={{ color: '#10b981' }}>숫자</span>로 확인하세요
                </h2>
                <p style={{ textAlign: 'center', color: '#94a3b8', fontSize: 16, marginBottom: 36 }}>
                    얼마나 많은 치과가 우리 기공소를 봤는지, 어디서 왔는지 한눈에
                </p>

                {/* 통계 미리보기 모킹 */}
                <div style={{
                    maxWidth: 900, margin: '0 auto',
                    background: 'linear-gradient(135deg, rgba(255,255,255,0.04), rgba(255,255,255,0.02))',
                    border: '1px solid rgba(255,255,255,0.08)',
                    borderRadius: 20, padding: isMobile ? 20 : 32,
                    backdropFilter: 'blur(10px)',
                }}>
                    {/* 4개 통계 카드 */}
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(4, 1fr)',
                        gap: 12, marginBottom: 24,
                    }}>
                        {[
                            { icon: Users, value: '12,847', label: '기공소 찾기 총 유입', color: '#f59e0b' },
                            { icon: Eye, value: '1,328', label: '우리 기공소 조회', color: '#10b981' },
                            { icon: TrendingUp, value: '487', label: '최근 7일', color: '#6366f1' },
                            { icon: Calendar, value: '53', label: '오늘', color: '#ef4444' },
                        ].map((s, i) => (
                            <div key={i} style={{
                                padding: 16, backgroundColor: 'rgba(255,255,255,0.05)',
                                borderRadius: 12, border: '1px solid rgba(255,255,255,0.06)',
                                textAlign: 'center',
                            }}>
                                <s.icon size={20} color={s.color} style={{ marginBottom: 6 }} />
                                <div style={{ fontSize: 24, fontWeight: 900, color: s.color }}>{s.value}</div>
                                <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>{s.label}</div>
                            </div>
                        ))}
                    </div>

                    {/* 전환율 강조 */}
                    <div style={{
                        padding: 16, backgroundColor: 'rgba(245,158,11,0.1)',
                        border: '1px solid rgba(245,158,11,0.2)',
                        borderRadius: 12, textAlign: 'center', marginBottom: 24,
                    }}>
                        <div style={{ fontSize: 12, color: 'rgba(245,158,11,0.8)', marginBottom: 4 }}>
                            기공소 찾기 → 우리 기공소 전환율
                        </div>
                        <div style={{ fontSize: 32, fontWeight: 900, color: '#f59e0b' }}>10.3%</div>
                    </div>

                    {/* 지역별 + 최근 방문 */}
                    <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 16 }}>
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 700, color: '#e2e8f0', marginBottom: 12 }}>
                                <MapPin size={14} color="#f59e0b" /> 유입 지역 분석
                            </div>
                            {[
                                { name: '서울 강남구', count: 287, max: 287 },
                                { name: '경기 김포시', count: 198, max: 287 },
                                { name: '부산 해운대구', count: 156, max: 287 },
                                { name: '인천 부평구', count: 124, max: 287 },
                            ].map((r, i) => (
                                <div key={i} style={{ marginBottom: 8 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 4 }}>
                                        <span style={{ color: '#cbd5e1' }}>{r.name}</span>
                                        <span style={{ color: '#f59e0b', fontWeight: 700 }}>{r.count}회</span>
                                    </div>
                                    <div style={{ height: 5, backgroundColor: 'rgba(255,255,255,0.06)', borderRadius: 3 }}>
                                        <div style={{ height: 5, backgroundColor: '#f59e0b', borderRadius: 3, width: `${(r.count / r.max) * 100}%` }} />
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 700, color: '#e2e8f0', marginBottom: 12 }}>
                                <Eye size={14} color="#10b981" /> 최근 방문 기록
                            </div>
                            {[
                                { region: '서울 강남구', time: '방금 전' },
                                { region: '경기 김포시', time: '8분 전' },
                                { region: '부산 해운대구', time: '23분 전' },
                                { region: '인천 부평구', time: '1시간 전' },
                            ].map((v, i) => (
                                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid rgba(255,255,255,0.06)', fontSize: 12 }}>
                                    <span style={{ color: '#cbd5e1' }}>{v.region}</span>
                                    <span style={{ color: '#94a3b8' }}>{v.time}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* 강조 메시지 */}
                <div style={{
                    marginTop: 24, padding: '14px 24px',
                    backgroundColor: 'rgba(16,185,129,0.08)',
                    border: '1px solid rgba(16,185,129,0.15)',
                    borderRadius: 14, textAlign: 'center',
                    maxWidth: 700, marginLeft: 'auto', marginRight: 'auto',
                }}>
                    <p style={{ fontSize: isMobile ? 14 : 16, fontWeight: 700, color: '#10b981', margin: 0 }}>
                        ✨ 광고 효과를 데이터로 검증할 수 있습니다
                    </p>
                    <p style={{ fontSize: 12, color: '#94a3b8', margin: '4px 0 0' }}>
                        지역별 유입, 전환율, 방문 시간까지 매일 업데이트
                    </p>
                </div>

                <div style={{ textAlign: 'center', margin: '24px 0' }}>
                    <button onClick={handleSignUp} style={{ padding: '14px 32px', fontSize: 15, fontWeight: 700, backgroundColor: '#6366f1', color: '#fff', border: 'none', borderRadius: 12, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                        구독 시작하기
                    </button>
                </div>
            </section>

            {/* ══════ 덴탈클러스터 추가 기능 ══════ */}
            <section style={{
                padding: isMobile ? '40px 20px' : '60px 40px',
                backgroundColor: 'rgba(255,255,255,0.03)',
            }}>
                <div style={{ maxWidth: 1200, margin: '0 auto' }}>
                    <h2 style={{ textAlign: 'center', fontSize: isMobile ? 24 : 32, fontWeight: 800, marginBottom: 12 }}>
                        홍보만이 아닙니다
                    </h2>
                    <p style={{ textAlign: 'center', color: '#94a3b8', fontSize: 16, marginBottom: 40 }}>
                        기공소 운영에 필요한 <span style={{ color: '#818cf8', fontWeight: 700 }}>모든 기능</span>이 구독에 포함됩니다
                    </p>

                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
                        gap: isMobile ? 12 : 16,
                    }}>
                        {features.map((f, i) => (
                            <div key={i} style={{
                                padding: isMobile ? '16px' : '24px 20px',
                                backgroundColor: 'rgba(255,255,255,0.05)',
                                borderRadius: 14, border: '1px solid rgba(255,255,255,0.06)',
                                textAlign: 'center',
                            }}>
                                <f.icon size={28} color="#818cf8" style={{ marginBottom: 10 }} />
                                <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 4 }}>{f.title}</div>
                                <div style={{ fontSize: 12, color: '#64748b' }}>{f.desc}</div>
                            </div>
                        ))}
                    </div>

                    <div style={{ textAlign: 'center', margin: '24px 0' }}>
                        <button onClick={handleSignUp} style={{ padding: '14px 32px', fontSize: 15, fontWeight: 700, backgroundColor: '#6366f1', color: '#fff', border: 'none', borderRadius: 12, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                            구독 시작하기
                        </button>
                    </div>
                </div>
            </section>

            {/* ══════ 구독 요금 ══════ */}
            <section style={{
                padding: isMobile ? '40px 20px' : '60px 40px',
                maxWidth: 1200, margin: '0 auto',
            }}>
                <h2 style={{ textAlign: 'center', fontSize: isMobile ? 24 : 32, fontWeight: 800, marginBottom: 40 }}>
                    심플한 <span style={{ color: '#818cf8' }}>요금제</span>
                </h2>

                <div style={{
                    maxWidth: 480, margin: '0 auto',
                    padding: isMobile ? '32px 24px' : '40px 36px',
                    backgroundColor: 'rgba(99,102,241,0.06)',
                    borderRadius: 24, border: '2px solid rgba(99,102,241,0.3)',
                    textAlign: 'center',
                }}>
                    <div style={{
                        display: 'inline-block', padding: '6px 16px',
                        backgroundColor: '#6366f1', borderRadius: 20,
                        fontSize: 13, fontWeight: 700, marginBottom: 20,
                    }}>
                        올인원 구독
                    </div>

                    <div style={{ marginBottom: 24 }}>
                        <span style={{ fontSize: isMobile ? 28 : 36, fontWeight: 900, color: '#fff' }}>월 정액 구독</span>
                    </div>

                    <div style={{ textAlign: 'left', marginBottom: 28 }}>
                        {/* 강조 항목 */}
                        <div style={{
                            display: 'flex', alignItems: 'center', gap: 10,
                            padding: '10px 12px', marginBottom: 8,
                            backgroundColor: 'rgba(16,185,129,0.1)', borderRadius: 10,
                            border: '1px solid rgba(16,185,129,0.2)',
                        }}>
                            <CheckCircle size={18} color="#10b981" />
                            <span style={{ fontSize: 14, color: '#10b981', fontWeight: 700 }}>영업사원 고용 대비 대폭 절감</span>
                        </div>
                        {[
                            '덴탈아리랑 배너 광고',
                            '치과신문 배너 광고',
                            '직접 방문 영업',
                            '전화 영업',
                            '인스타그램 광고',
                            '기공소 프로필 페이지',
                            '주문관리 · 채팅 · 거래명세서',
                            '매출 분석 · 일정 관리',
                            '모바일 앱 (iOS/Android)',
                        ].map((item, i) => (
                            <div key={i} style={{
                                display: 'flex', alignItems: 'center', gap: 10,
                                padding: '8px 0', borderBottom: i < 8 ? '1px solid rgba(255,255,255,0.05)' : 'none',
                            }}>
                                <CheckCircle size={18} color="#10b981" />
                                <span style={{ fontSize: 14, color: '#e2e8f0' }}>{item}</span>
                            </div>
                        ))}
                    </div>

                    <button onClick={handleSignUp} style={{
                        width: '100%', padding: '16px',
                        fontSize: 17, fontWeight: 700,
                        backgroundColor: '#6366f1', color: '#fff', border: 'none',
                        borderRadius: 14, cursor: 'pointer', display: 'flex',
                        alignItems: 'center', justifyContent: 'center', gap: 10,
                    }}>
                        <Crown size={20} /> 구독 시작하기
                    </button>
                    <p style={{ fontSize: 12, color: '#64748b', marginTop: 10 }}>
                        약정 없음 · 언제든 해지 가능
                    </p>
                </div>
            </section>

            {/* ══════ 숫자로 보는 덴탈클러스터 ══════ */}
            <section style={{
                padding: isMobile ? '40px 20px' : '60px 40px',
                maxWidth: 1200, margin: '0 auto',
            }}>
                <h2 style={{ textAlign: 'center', fontSize: isMobile ? 24 : 32, fontWeight: 800, marginBottom: 36 }}>
                    숫자로 보는 <span style={{ color: '#818cf8' }}>덴탈클러스터</span>
                </h2>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
                    gap: 16, maxWidth: 900, margin: '0 auto',
                }}>
                    {[
                        { label: '등록 기공소', value: '80+', color: '#818cf8' },
                        { label: '치과 노출', value: '5,000+', color: '#10b981' },
                        { label: '덴탈아리랑 배너', value: '월 10만+', sub: '노출', color: '#f59e0b' },
                        { label: '인스타그램 광고', value: '월 50,000+', sub: '도달', color: '#f43f5e' },
                    ].map((stat, i) => (
                        <div key={i} style={{
                            padding: '24px 16px',
                            backgroundColor: 'rgba(255,255,255,0.04)',
                            borderRadius: 16, border: '1px solid rgba(255,255,255,0.08)',
                            textAlign: 'center',
                        }}>
                            <div style={{ fontSize: isMobile ? 28 : 36, fontWeight: 900, color: stat.color, marginBottom: 4 }}>
                                {stat.value}
                            </div>
                            {stat.sub && <div style={{ fontSize: 13, color: '#94a3b8', marginBottom: 2 }}>{stat.sub}</div>}
                            <div style={{ fontSize: 14, color: '#e2e8f0', fontWeight: 600 }}>{stat.label}</div>
                        </div>
                    ))}
                </div>
            </section>

            {/* ══════ FAQ ══════ */}
            <section style={{
                padding: isMobile ? '40px 20px' : '60px 40px',
                backgroundColor: 'rgba(255,255,255,0.03)',
            }}>
                <div style={{ maxWidth: 700, margin: '0 auto' }}>
                    <h2 style={{ textAlign: 'center', fontSize: isMobile ? 24 : 32, fontWeight: 800, marginBottom: 32 }}>
                        자주 묻는 질문
                    </h2>
                    {faqs.map((faq, i) => (
                        <div key={i} style={{
                            padding: '20px 24px', marginBottom: 12,
                            backgroundColor: 'rgba(255,255,255,0.05)',
                            borderRadius: 14, border: '1px solid rgba(255,255,255,0.06)',
                        }}>
                            <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 8, color: '#e2e8f0' }}>
                                Q. {faq.q}
                            </div>
                            <div style={{ fontSize: 14, color: '#94a3b8', lineHeight: 1.7 }}>
                                {faq.a}
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* ══════ 최종 CTA ══════ */}
            <section style={{
                padding: isMobile ? '60px 20px' : '80px 40px',
                textAlign: 'center',
            }}>
                <h2 style={{ fontSize: isMobile ? 26 : 36, fontWeight: 900, marginBottom: 16 }}>
                    지금 바로 시작하세요
                </h2>
                <p style={{ fontSize: 16, color: '#94a3b8', marginBottom: 32, lineHeight: 1.7 }}>
                    5가지 채널 홍보 + 기공소 운영 기능까지 한 번에.<br />
                    기공소는 기술에만 집중하세요.
                </p>
                <button onClick={handleSignUp} style={{
                    padding: isMobile ? '18px 40px' : '20px 56px',
                    fontSize: isMobile ? 17 : 20, fontWeight: 700,
                    backgroundColor: '#6366f1', color: '#fff', border: 'none',
                    borderRadius: 16, cursor: 'pointer', display: 'inline-flex',
                    alignItems: 'center', gap: 12,
                }}>
                    <Crown size={22} /> 구독 시작하기
                </button>

                <div style={{ marginTop: 40, color: '#475569', fontSize: 13 }}>
                    <p>문의: 010-2972-3733 | 카카오톡: @덴탈클러스터</p>
                    <p style={{ marginTop: 4 }}>&copy; 2026 DentalCluster. All rights reserved.</p>
                </div>
            </section>
        </div>
    );
}

export default LabPromoLanding;
